import React from 'react';
import ReportComponent from './component/ReportComponent';
import { Route, Switch } from 'react-router-dom';
import { getInitialData } from '../../actions/index'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FetchReportComponent from './FetchReportComponent';

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chart: props.chartvalues
    }
  }
  componentDidUpdate() {
    jQuery(".active").removeClass("active");
    jQuery("#liReport").addClass("active");
  }
  render() {
    return (
      <Switch>
        {/* <Route exact path={`${this.props.match.url}`} component={({ }) => (
          <ReportComponent drillHandle={this.props.drillHandle} />
        )} /> */}
        <Route exact path={`/report`} component={ReportComponent} />
        <Route path={`${this.props.match.url}/SavedReport`} component={FetchReportComponent} />
      </Switch>
    )
  }
}

function mapStateToProps(state) {
  var chartvalues = state.dataSet.alfred;
  return {
    chartvalues: chartvalues,
    dataSet: state.dataSet.dataSet
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getInitialData
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Report);